import { Injectable } from '@angular/core';
import { SimpleMQ } from 'ng2-simple-mq';
import { CommonService } from './common.service';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/Rx';
import * as _ from 'lodash';

import { User, UserByComune } from '../models/user';

@Injectable()
export class ComuniService {
	public flowInit: boolean = true;
	public loginByToken: boolean = false;
	public aritUser: boolean = false;
	private pageOpened: string;
	private user: any = null;

	// comuniDisponibili
	private comuniDisponibili: any[] = [];
	private _comuniDisponibiliSource = new BehaviorSubject<any[]>([]);
	public comuniDisponibili$ = this._comuniDisponibiliSource.asObservable();

	//comune
	private comune: any = null;
	private _comuneSource = new BehaviorSubject<any>(null);
	public comune$ = this._comuneSource.asObservable();

	//operatori
	private operatori: any[] = [];
	private _operatoriSource = new BehaviorSubject<any[]>([]);
	public operatori$ = this._operatoriSource.asObservable();

	//cittadini
	private cittadini: any[] = [];
	private _cittadiniSource = new BehaviorSubject<any[]>([]);
	public cittadini$ = this._cittadiniSource.asObservable();

	constructor(private commonService: CommonService, private smq: SimpleMQ) {
		console.log("SRV|COMUNI - ALIVE!");
		this.comune = null;
		this.smq.subscribe('comuni', e => this.receiveMsg(e));
	}

	receiveMsg(m) {
		console.log('SRV|COMUNI - receiveMsg:', m);
		if(m){
			let msgSender = m.sender;
			let msgType = m.type;
			let msgKey = m.key;
			let msgValue = m.value;
			switch(msgType){
				case 'richiesta':
					switch(msgKey){
						case 'comuneId':
							this.sendMsg(msgSender, 'risposta', msgKey, this.comune.id);
							break;
						default:
							console.log('SRV|COMUNI - receiveMsg: class', this);
					}
					break;
				case 'risposta':
					switch(msgKey){
						case 'pageOpened':
							this.pageOpened = msgValue;
							break;
						case 'user':
							this.user = msgValue;
							break;
						default:
							console.log('SRV|COMUNI - receiveMsg: risposta class', this);
					}
					break;
				default:
					console.log('SRV|COMUNI - receiveMsg: msgType', msgType);
			}
		}
	}

	sendMsg(name: string, type: any, key: any, value: any = null) {
		// Publish to queue name
		let m = {
			sender: 'comuni',
			type: type,
			key: key,
			value: value,
		};
		console.log('SRV|COMUNI - sendMsg:', m);
		this.smq.publish(name, m);
	}

	getComuniAll() {
		return this.commonService.getDB().getElementsByTable('comuni');
	}

	getComuniByIds(idMunicipalityAuthorized: any) {
		let localTable = null;
		let localFilters = [];
		let localComuneId = null;
		console.log("getComuniByIds", idMunicipalityAuthorized);
		localFilters.push({ type: "IN", key: "id", value: JSON.stringify(idMunicipalityAuthorized) });
		console.log("getComuniByIds", localFilters);
		return this.commonService.getDB().getElementsByQuery('comuni', localTable, localFilters, localComuneId);
	}

	getComuniDisponibili(userByComune: UserByComune){
		let getter: any;
		console.log("SRV|COMUNI - getComuniDisponibili userByComune", userByComune);
		if(userByComune.idMunicipalityAuthorized){
			if(userByComune.idMunicipalityAuthorized == 'superadmin'){
				console.log("SRV|COMUNI - superadmin");
				getter = this.getComuniAll();
			}else if(userByComune.userComplete.roles.length){
				console.log("SRV|COMUNI - operatore");
				getter = this.getComuniByIds(userByComune.idMunicipalityAuthorized);
			}else if(userByComune.userComplete.id_anagrafica){
				console.log("SRV|COMUNI - cittadino 1");
				// rivedere - comuni visibili al cittadino
				getter = this.getComuniCittadino(userByComune.userComplete);
			}else{
				console.log("SRV|COMUNI - cittadino senza anagrafica");
			}
		}else if(userByComune.userComplete.id_anagrafica){
			console.log("SRV|COMUNI - cittadino 2");
			// rivedere - comuni visibili al cittadino
			getter = this.getComuniCittadino(userByComune.userComplete);
		}else{
			console.log("SRV|COMUNI - cittadino senza anagrafica 2");
		}

		if(getter){
			getter.subscribe(
				data => { this.comuniDisponibili = this.commonService.readDatabaseResponse('', data); },
				error => { console.log(error); },
				() => {
					console.log("SRV|COMUNI - COMUNI DISPONIBILI:", this.comuniDisponibili);
					if(this.comuniDisponibili && this.comuniDisponibili.length){
						let idComuneLocal = this.loadIdComuneSelected();
						this.sendMsg('data', 'cambioComune', 'idComune', idComuneLocal);
						this.cambioComune(userByComune.userComplete, idComuneLocal);
						this._comuniDisponibiliSource.next(this.comuniDisponibili);

						this.getOperatori(userByComune);
						this.sendMsg("data", "richiesta", "pageOpened");
						if(this.pageOpened){
							this.commonService.getRouter().navigate([this.pageOpened]);
						}
					}
				}
			);
		}
	}

	getComuniCittadino(user: User) {
		let localTable = null;
		let localFilters = [];
		let localComuneId = null;
		console.log("SRV|COMUNI - getComuniCittadino", user.id_anagrafica);
		localFilters.push({ type: "=", key: "anagrafica_id", value: user.id_anagrafica });
		console.log("SRV|COMUNI - getComuniCittadino", localFilters);
		return this.commonService.getDB().getElementsByQuery('comuni_cittadino', localTable, localFilters, localComuneId);
	}

	getCittadini(){
		console.log("SRV|COMUNI - INIZIO CITTADINI", this.comune);
		this.commonService.getDB().getCittadini(this.comune.id)
			.subscribe(
				data => {
					this.cittadini = data.cittadini;
					let data_registrazioneTemp = null;
					let data_certificazioneTemp = null;
					let ultimoAccessoTemp = null;
					let ultimoAccessoLungoTemp = null;
					for(let cittadino of this.cittadini){
						//  codice_fiscale
						if(cittadino.codice_fiscale){
							cittadino.codice_fiscale = cittadino.codice_fiscale.toUpperCase();
						}
						//  data_registrazione
						data_registrazioneTemp = this.commonService.getLocale().toLocaleDateTime(cittadino.registrazione);
						cittadino.data_registrazione = data_registrazioneTemp;
						//  certificazione
						cittadino.certificazione = Boolean(Number(cittadino.certificazione));
						//  data_certificazione
						data_certificazioneTemp = this.commonService.getLocale().toLocaleDate(cittadino.data_certificazione);
						cittadino.data_certificazione = data_certificazioneTemp;
						//  ultimoAccesso
						ultimoAccessoTemp = this.commonService.getLocale().toLocaleDate(cittadino.ultimoAccesso);
						cittadino.ultimoAccesso = ultimoAccessoTemp;
						//  ultimoAccessoLungo
						ultimoAccessoLungoTemp = this.commonService.getLocale().toLocaleDateTime(cittadino.ultimoAccessoLungo);
						cittadino.ultimoAccesso = ultimoAccessoLungoTemp;
					}
				},
				error => { console.log(error); },
				() => {
					this._cittadiniSource.next(this.cittadini);
					console.log("SRV|COMUNI - CITTADINI", this.cittadini);
				}
			);
	}

	getUserLevelId(userByComune: UserByComune){
		let comuneId = this.comune.id;
		console.log("SRV|UTENTI - getUserLevelId", userByComune);
		let levelId: number = null;
		if (userByComune.permissions) {
			if (userByComune.permissions == 'superadmin') {
				levelId = 1;
			}else if (userByComune.permissions[comuneId]) {
				if (userByComune.permissions[comuneId] == 'amministratore') {
					levelId = 2;
				}else {
					levelId = Number(userByComune.permissions[comuneId].livello);
				}
			}
		}
		console.log("SRV|UTENTI - getUserLevelId", levelId);
		return levelId;
	}

	getOperatori(userByComune: UserByComune){
		let userLevelId = this.getUserLevelId(userByComune);
		console.log("SRV|COMUNI - getOperatori userLevelId", userLevelId, "userByComune", userByComune, "comune", this.comune);
		if(userLevelId){
			this.commonService.getDB().getOperatori(userLevelId, this.comune.id)
				.subscribe(
					data => {
						//console.log("SRV|COMUNI - GET_OPERATORI", data);
						this.operatori = data.operatori;
						let data_registrazioneTemp = null;
						let data_certificazioneTemp = null;
						let ultimoAccessoTemp = null;
						let ultimoAccessoLungoTemp = null;
						for(let operatore of this.operatori){
							//  codice_fiscale
							if(operatore.codice_fiscale){
								operatore.codice_fiscale = operatore.codice_fiscale.toUpperCase();
							}
							//  data_registrazione
							data_registrazioneTemp = this.commonService.getLocale().toLocaleDateTime(operatore.registrazione);
							operatore.data_registrazione = data_registrazioneTemp;
							//  certificazione
							operatore.certificazione = Boolean(Number(operatore.certificazione));
							//  data_certificazione
							data_certificazioneTemp = this.commonService.getLocale().toLocaleDate(operatore.data_certificazione);
							operatore.data_certificazione = data_certificazioneTemp;
							//  ultimoAccesso
							ultimoAccessoTemp = this.commonService.getLocale().toLocaleDate(operatore.ultimoAccesso);
							operatore.ultimoAccesso = ultimoAccessoTemp;
							//  ultimoAccessoLungo
							ultimoAccessoLungoTemp = this.commonService.getLocale().toLocaleDateTime(operatore.ultimoAccessoLungo);
							operatore.ultimoAccesso = ultimoAccessoLungoTemp;
						}
					},
					error => { console.log(error); },
					() => {
						this._operatoriSource.next(this.operatori);
						console.log("SRV|COMUNI - OPERATORI", this.operatori);
					}
				);
		}
	}

	loadIdComuneSelected(){
		let local_id_comune = null;
		//	localstorage
		local_id_comune = localStorage.getItem("id_comune");
		console.log("SRV|COMUNI - LOCALSTORAGE:", local_id_comune, this.comuniDisponibili);
		if((this.loginByToken || this.aritUser) && local_id_comune){
			console.log("SRV|COMUNI - COMUNI DISPONIBILI A", this.user);
			//local_comune = this.getComuneByIndex(local_id_comune);
		}else{
			console.log("SRV|COMUNI - COMUNI DISPONIBILI B", this.comuniDisponibili);
			local_id_comune =  this.comuniDisponibili[0].id;
		}
		console.log("SRV|COMUNI - LOCAL COMUNE", local_id_comune);
		return local_id_comune;
	}

	getComune(){
		if(this.comune)
			return this.comune;
		else
			return null;
	}

	getComuneId(){
		if(this.comune)
			return this.comune.id;
		else
			return -1;
	}

	getComuneCodice(){
		return this.comune.codice;
	}

	getComuneNome(){
		return this.comune.nome;
	}

	resetComune(){
		this.comune = null;
	}

	cambioComune(user: User, comuneId: any){
		//console.log("SRV|COMUNI - CAMBIO COMUNE INIZIO", comuneId, this.comuniDisponibili, this.comune);
		console.log("SRV|COMUNI - CAMBIO COMUNE", user, comuneId, this.comune);
		if(comuneId){
			if (this.comune) {
				if (this.comune.id != comuneId) {
					this.applicaCambioComune(user, comuneId);
				}
			} else {
				this.applicaCambioComune(user, comuneId);
			}
		}
	}

	applicaCambioComune(user, comuneId) {
		this.comune = null;
		this.flowInit = true;
		for (let comune of this.comuniDisponibili) {
			if (comune.id == comuneId) {
				this.setValueComune(user, comune);
			}
		}
		if(!this.comune && this.comuniDisponibili.length){
			this.setValueComune(user, this.comuniDisponibili[0]);
		}
		console.log("SRV|COMUNI - APPLICA CAMBIO COMUNE", user.id, comuneId, this.comune, this.comuniDisponibili);
	}

	setValueComune(user, comune){
		console.log("SRV|COMUNI - setValueComune", user, comune);
		this.comune = comune;
		this._comuneSource.next(this.comune);
		let comuneId = comune.id;
		console.log("SRV|COMUNI - SEND COMUNE ID", comuneId);
		localStorage.setItem("id_comune", String(comuneId));
		this.commonService.getDB().socketService.addActivity(user.id, comuneId, "cambioComune", comuneId, true);
		this.commonService.getDB().socketService.setIdComune(comuneId);
		console.log("SRV|COMUNI - COMUNE", this.comune);
	}
}
